import {
  Rocket,
  Briefcase,
  Building2,
  Newspaper,
  ShoppingCart,
  AppWindow,
} from "lucide-react";

export const packagesData = [
  {
    name: "Landing Page",
    icon: Rocket,
    priceRange: "₦100,000 – ₦180,000",
    description:
      "A professionally designed single-page website perfect for promoting a business, service, event, or personal brand.",
    includes: [
      "Custom modern design",
      "Fully responsive (Mobile, Tablet & Desktop)",
      "Contact form",
      "WhatsApp integration",
      "Social media integration",
      "Basic SEO setup",
      "Fast loading speed",
      "Call-to-action sections",
    ],
    idealFor: [
      "Startups",
      "Personal Brands",
      "Events",
      "Product Launches",
      "Marketing Campaigns",
    ],
  },
  {
    name: "Portfolio Website",
    icon: Briefcase,
    priceRange: "₦180,000 – ₦350,000",
    description:
      "Present your work professionally and build credibility with potential clients or employers.",
    includes: [
      "Home Page",
      "About Page",
      "Portfolio Gallery",
      "Services Page",
      "Contact Page",
      "Resume/CV Download",
      "Contact Form",
      "Mobile Responsive Design",
      "Basic SEO Optimization",
    ],
    idealFor: [
      "Designers",
      "Developers",
      "Photographers",
      "Architects",
      "Freelancers",
      "Creative Professionals",
    ],
  },
  {
    name: "Business Website",
    icon: Building2,
    priceRange: "₦300,000 – ₦700,000",
    description:
      "A professional website that strengthens your online presence and helps customers learn about your business and services.",
    note: "Adding a blog or additional custom features may affect the final project cost.",
    includes: [
      "Up to 10 Pages",
      "Home",
      "About Us",
      "Services",
      "Gallery",
      "Contact Page",
      "Blog (Optional)",
      "Google Maps Integration (Optional)",
      "WhatsApp Integration",
      "Social Media Links",
      "Contact Forms",
      "Mobile Responsive Design",
      "Speed Optimization",
      "Basic SEO",
    ],
    idealFor: [
      "Small Businesses",
      "Corporate Organizations",
      "Schools",
      "Churches",
      "NGOs",
      "Professional Service Providers",
    ],
  },
  {
    name: "Blog / News Website",
    icon: Newspaper,
    priceRange: "₦350,000 – ₦600,000",
    description:
      "A content management website designed for publishing articles, blogs, or news updates.",
    includes: [
      "Admin Dashboard",
      "Article Management",
      "Categories",
      "Search Functionality",
      "Comment System",
      "Mobile Responsive Design",
      "SEO-Friendly Structure",
      "Social Sharing Features",
    ],
    idealFor: [
      "Bloggers",
      "News Platforms",
      "Educational Institutions",
      "Content Creators",
    ],
  },
  {
    name: "E-Commerce Website",
    icon: ShoppingCart,
    priceRange: "₦700,000 – ₦1,200,000+",
    description:
      "Launch your online store with secure payments, inventory management, and a complete shopping experience.",
    includes: [
      "Everything in the Business Website Plus",
      "Custom Admin Dashboard",
      "Product Management",
      "Categories",
      "Shopping Cart",
      "Customer Accounts",
      "Secure Checkout",
      "Payment Gateway Integration",
      "Order Management",
      "Inventory Management",
      "Email Notifications",
      "Sales Dashboard",
      "Mobile Responsive Design",
      "SEO Optimization",
    ],
    idealFor: [
      "Fashion Stores",
      "Supermarkets",
      "Beauty Brands",
      "Electronics Stores",
      "Pharmacies",
      "Businesses Selling Products Online",
    ],
  },
  {
    name: "Custom Web Application",
    icon: AppWindow,
    priceRange: "Starting From ₦1,000,000",
    description:
      "Fully customized web applications tailored to your business operations and workflow.",
    note: "Final pricing depends on project requirements, integrations, complexity, and development timeline.",
    includes: [
      "School Management Systems",
      "Hospital Management Systems",
      "Booking Platforms",
      "Hotel Management Systems",
      "Real Estate Platforms",
      "CRM Systems",
      "Inventory Management Systems",
      "HR Systems",
      "Customer Portals",
      "Fintech Applications",
      "Analytics Dashboards",
      "Internal Business Tools",
    ],
    idealFor: [
      "Unique Business Operations",
      "Custom Workflows",
      "Scalable Internal Tools",
    ],
  },
];

export const addOnsData = [
  { service: "Additional Website Page", price: "₦20,000" },
  { service: "Professional Business Email Setup", price: "₦15,000" },
  { service: "Logo Design", price: "₦20,000 – ₦50,000" },
  { service: "Content Writing", price: "₦15,000 per page" },
  { service: "Payment Gateway Integration", price: "From ₦80,000" },
  { service: "Live Chat Integration", price: "₦40,000" },
  { service: "Google Analytics Setup", price: "₦30,000" },
  { service: "Website Maintenance", price: "From ₦30,000/month" },
  { service: "SEO Optimization (Advanced)", price: "Quotation Available" },
  { service: "Website Redesign", price: "Quotation Available" },
];
